import i18n from '@/lang/i18n'
export default {
  checklists: [],
  checklistAll: [],
  last_page: 0,
  total: 0,
  checklist: {
    group_checklist_items: [],
    checklist_info: {},
    checklist_users: [],
    group_of_checklists: []
  },
  checklist_permissions: [],
  fields: [
    {
      key: 'status',
      label: i18n.t('checklist.attribute.status'),
      sortable: true,
      tdClass: 'col-md-2'
    },
    {
      key: 'name',
      label: i18n.t('checklist.attribute.name'),
      sortable: true
    },
    {
      key: 'view_user',
      label: '',
      sortable: true
    },
    {
      key: 'organization',
      label: i18n.t('checklist.attribute.organization'),
      sortable: true
    },
    {
      key: 'action',
      label: i18n.t('checklist.attribute.action')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/module/checklist/state.js